import { __decorate, __metadata } from "tslib";
import { IsUndefinable, IsUUIDWithLVS, StoreItemPromotionRelationType } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { Equals, IsBoolean } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class PatchStoreItemDiscountedPromotionTargetRelationDto {
    constructor() {
        this.type = StoreItemPromotionRelationType.DISCOUNTED;
        this.canQuantityBeModified = true;
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Promotion uuid', example: '221c50e5-9b2d-4d97-82c1-8ced9eb0fa98' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsUUIDWithLVS('4'),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchStoreItemDiscountedPromotionTargetRelationDto.prototype, "promotionUuid", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreItemPromotionRelationType, default: StoreItemPromotionRelationType.DISCOUNTED }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    Equals(StoreItemPromotionRelationType.DISCOUNTED, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchStoreItemDiscountedPromotionTargetRelationDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], PatchStoreItemDiscountedPromotionTargetRelationDto.prototype, "canQuantityBeModified", void 0);
//# sourceMappingURL=PatchStoreItemDiscountedPromotionTargetRelationDto.js.map